import * as React from 'react'
import { Link, useIntl, FormattedMessage } from 'gatsby-plugin-react-intl'


export const CookieConsent = ({ onAccept, onDecline }: { onAccept: () => void, onDecline: () => void }) => {
    const intl = useIntl()

    return (<div className="cookie__consent">
        <div className="row">
            <div className="col col--md--8 col--is--12">
                <p className="cookie__consent--text">
                    <span><FormattedMessage id="common.cookieConsent.message"/>
                     <a href={'/cookie-policy'} target={'_blank'} className="text--red"> {' '} <FormattedMessage id="common.cookieConsent.link"/> </a>
                    </span></p>
            </div>
            <div className="col col--md--2 col--is--6 cookie__consent__button--wrapper">
                <button type="button" className="cookie__consent__button cookie__consent__button--decline" onClick={onDecline} tabIndex={1}><FormattedMessage id="common.buttons.decline" /></button>
            </div>
            <div className="col col--md--2 col--is--6 cookie__consent__button--wrapper">
                <button type="button" className="cookie__consent__button cookie__consent__button--accept" onClick={onAccept} tabIndex={1}><FormattedMessage id="common.buttons.accept"/></button>
            </div>
            
        </div>
    </div>)
}